import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "user", "organisation", "tournament", "publicTournament"],
};

export default persistConfig;
